export enum PERMISSION_TYPE {
  USER_APP_PERMISSIONS = 'user_app_perms',
  USER_RESOURCE_PERMISSION = 'user_resource_perms',
  USER_RESOURCE_CHILD_PERMISSIONS = 'user_resource_perms',
  ROLE_PERMISSIONS = 'role_perms'
}

export enum USER_APP_PERMISSIONS {
  CREATE_OWN_USER_GROUPS = 'create-own-user-groups',
  CREATE_USER_GROUPS = 'create-user-groups',
  CREATE_USERS = 'create-users',
  CREATE_ROLES = 'create-roles',
  CREATE_ROOT_FOLDER_CONTENT = 'create-root-folder-content',
  DELETE_OWN_USER_GROUPS = 'delete-own-user-groups',
  DELETE_USER_GROUPS = 'delete-user-groups',
  DELETE_USERS = 'delete-users',
  DELETE_ROLES = 'delete-roles',
  DELETE_ROOT_FOLDER_CONTENT = 'delete-root-folder-content',
  EDIT_OWN_USER_GROUPS = 'edit-own-user-groups',
  EDIT_USER_GROUPS = 'edit-user-groups',
  EDIT_USERS = 'edit-users',
  EDIT_ROLES = 'edit-roles',
  EDIT_ROOT_FOLDER_CONTENT = 'edit-root-folder-content',
  VIEW_OWN_USER_GROUPS = 'view-own-user-groups',
  VIEW_USER_GROUPS = 'view-user-groups',
  VIEW_USERS = 'view-users',
  VIEW_ROLES = 'view-roles',
  VIEW_ROOT_FOLDER_CONTENT = 'view-root-folder-content',
  VIEW_ANALYTICS = 'view-usage-analytics',
  ADMIN_CONSOLE = 'create-admin-console'
}

export enum USER_RESOURCE_PERMISSION {
  VIEW_FILES_FOLDERS = 'view-files-folders',
  QUERY_FILES_FOLDERS = 'query-files-folders',
  DOWNLOAD_FILES = 'download-files',
  CREATE_FOLDERS = 'create-folders',
  UPLOAD_FILES_FOLDERS = 'upload-files-folders',
  DELETE_FILES_FOLDERS = 'delete-files-folders',
  RENAME_FILES_FOLDERS = 'rename-files-folders',
  MOVE_FILES_FOLDERS = 'move-files-folders',
  COPY_FILES_FOLDERS = 'copy-files-folders',
  ASSIGN_USER_ROLES = 'access-control',
  TAG_UNTAG_FILES = 'tag-untag-files'
}

export enum FEATURE_PERMISSIONS {
  CHAT = 'R_FTR_CHAT.PT_ENABLE_FEATURE',
  ASSISTANTS = 'R_FTR_ASSISTANTS.PT_ENABLE_FEATURE',
  PROJECTS = 'R_FTR_PROJECTS.PT_ENABLE_FEATURE',
  WORKFLOWS = 'R_FTR_WORKFLOWS.PT_ENABLE_FEATURE',
  APPS = 'R_FTR_APPS.PT_ENABLE_FEATURE',
  WORKSPACES = 'R_FTR_WORKSPACES.PT_ENABLE_FEATURE',

  RESOURCE_PROVIDER_CONFIG = 'R_FTR_INTEGRATIONS.PT_ENABLE_FEATURE',

  CONNECTORS = 'R_FTR_CONNECTORS.PT_ENABLE_FEATURE',
  ADVANCE_SEARCH = 'R_FTR_ADVANCE_SEARCH.PT_ENABLE_FEATURE',

  WORKSPACES_ENTERPRISE_KNOWLEDGE_CAPABILITY = 'CAPABILITY.Enterprise Knowledge',

  CHAT_ENTERPRISE_KNOWLEDGE = 'R_SFTR_ENTERPRISE_KNOWLEDGE.PT_ENABLE_SUBFEATURE',
  CHAT_ENTERPRISE_KNOWLEDGE_IMAGE_GENERATION = 'R_SFTR_ENTERPRISE_KNOWLEDGE.PT_IMAGE_GENERATION',
  CHAT_ENTERPRISE_KNOWLEDGE_MODEL_COMPARISON = 'R_SFTR_ENTERPRISE_KNOWLEDGE.PT_MODEL_COMPARISON',
  CHAT_ENTERPRISE_KNOWLEDGE_ATTACHMENTS = 'R_SFTR_ENTERPRISE_KNOWLEDGE.PT_ATTACHMENTS',
  CHAT_WORLD_KNOWLEDGE = 'R_SFTR_WORLD_KNOWLEDGE.PT_ENABLE_SUBFEATURE',
  CHAT_WORLD_KNOWLEDGE_WEB_SEARCH = 'R_SFTR_WORLD_KNOWLEDGE.PT_WEB_SEARCH',
  CHAT_WORLD_KNOWLEDGE_IMAGE_GENERATION = 'R_SFTR_WORLD_KNOWLEDGE.PT_IMAGE_GENERATION',
  CHAT_WORLD_KNOWLEDGE_MODEL_COMPARISON = 'R_SFTR_WORLD_KNOWLEDGE.PT_MODEL_COMPARISON',
  CHAT_WORLD_KNOWLEDGE_ATTACHMENTS = 'R_SFTR_WORLD_KNOWLEDGE.PT_ATTACHMENTS',

  ASSISTANT_CHAT = 'R_SFTR_ASSISTANT_CHAT.PT_ENABLE_SUBFEATURE',
  ASSISTANT_CHAT_ATTACHMENTS = 'R_SFTR_ASSISTANT_CHAT.PT_ATTACHMENTS',
  MANAGE_ASSISTANTS = 'R_SFTR_MANAGE_ASSISTANTS.PT_ENABLE_SUBFEATURE',
  MANAGE_ASSISTANTS_CONNECTORS = 'R_SFTR_MANAGE_ASSISTANTS.PT_CONNECTORS',
  MANAGE_ASSISTANTS_ENTERPRISE_KNOWLEDGE = 'R_SFTR_MANAGE_ASSISTANTS.PT_ENTERPRISE_KNOWLEDGE',
  MANAGE_ASSISTANTS_WEB_SEARCH = 'R_SFTR_MANAGE_ASSISTANTS.PT_WEB_SEARCH',
  MANAGE_ASSISTANTS_WORLD_KNOWLEDGE = 'R_SFTR_MANAGE_ASSISTANTS.PT_WORLD_KNOWLEDGE',

  PROJECTS_CHAT = 'R_SFTR_PROJECT_CHAT.PT_ENABLE_SUBFEATURE',
  PROJECT_CHAT_ATTACHMENTS = 'R_SFTR_PROJECT_CHAT.PT_ATTACHMENTS',
  PROJECTS_MANAGE = 'R_SFTR_MANAGE_PROJECT.PT_ENABLE_SUBFEATURE',
  PROJECTS_MANAGE_SOURCE = 'R_SFTR_MANAGE_PROJECT.PT_PROJECT_SOURCE',

  WORKFLOW_MANAGE = 'R_SFTR_MANAGE_WORKFLOW.PT_ENABLE_SUBFEATURE',
  WORKFLOWS_ENTERPRISE_KNOWLEDGE = 'R_SFTR_MANAGE_WORKFLOW.PT_ENTERPRISE_KNOWLEDGE',
  WORKFLOWS_MANAGE = 'R_SFTR_MANAGE_WORKFLOW.PT_MANAGE_WORKFLOWS',
  WORKFLOWS_RUN = 'R_SFTR_MANAGE_WORKFLOW.PT_RUN_WORKFLOWS',

  WORKSPACES_SUBFEATURE = 'R_SFTR_WORKSPACES.PT_ENABLE_SUBFEATURE',

  SMART_MEET = 'R_SFTR_SMART_MEET.PT_ENABLE_SUBFEATURE',
  DOC_ANALYST = 'R_SFTR_DOC_ANALYST.PT_ENABLE_SUBFEATURE',
  DATA_ANALYST = 'R_SFTR_DATA_ANALYST.PT_ENABLE_SUBFEATURE',

  CONNECTORS_SUBFEATURE = 'R_SFTR_CONNECTORS.PT_ENABLE_SUBFEATURE',

  ADVANCE_SEARCH_SUBFEATURE = 'R_SFTR_ADVANCE_SEARCH.PT_ENABLE_SUBFEATURE',

  CONFLUENCE = 'R_SFTR_CONFLUENCE.PT_ENABLE_SUBFEATURE',
  GOOGLE_DRIVE = 'R_SFTR_GOOGLE_DRIVE.PT_ENABLE_SUBFEATURE',
  ONEDRIVE = 'R_SFTR_ONEDRIVE.PT_ENABLE_SUBFEATURE',
  SHAREPOINT = 'R_SFTR_SHAREPOINT.PT_ENABLE_SUBFEATURE'
}

export enum RESOURCE_TYPE {
  WORKSPACE = 'RT_WORKSPACE',
  COLLECTION = 'RT_COLLECTION',
  FOLDER = 'RT_FOLDER',
  FILE = 'RT_FILE',
  NAMESPACE = 'RT_NAMESPACE',
  PUBLIC_WORKSPACE = 'RT_PUBLIC_WORKSPACE',
  FOUND_WORKSPACE = 'RT_FOUND_WORKSPACE',
  PRIVATE_WORKSPACE = 'RT_PRIVATE_WORKSPACE',
  FOUND_COLLECTION = 'RT_FOUND_COLLECTION',
  ASSISTANT = 'RT_ASSISTANT',
  TAG = 'RT_TAG',
  SMART_MEET = 'RT_SMART_MEET',
  PROJECT = 'RT_PROJECT'
}

export enum FAVOURITE_TYPE {
  RESOURCE = 'F',
  ASSISTANT = 'A',
  ADMIN_CONSOLE = 'C',
  PROJECT = 'P'
}

export enum UPLOAD_TYPE {
  FILE = 'file',
  FOLDER = 'folder',
  CHAT_FILE = 'chat_file',
  PROJECT_FILE = 'project_file',
  URL = 'url'
}

export enum FILE_UPLOADING_STATUS {
  IDLE = 'idle',
  PREPARING = 'preparing',
  UPLOADING = 'uploading',
  UPLOADED = 'uploaded',
  FAILED = 'failed',
  PENDING = 'pending',
  DROPPED = 'dropped',
  QUEUED = 'queued'
}

export enum FILE_UPLOAD_ERROR_MESSAGES {
  UNSUPPORTED = 'Unsupported',
  FILE_TOO_LARGE = 'File too large',
  CANCELLED_BY_USER = 'Cancelled by user'
}

export enum DEFAULT_CONTENT_ROLES {
  VIEWER = 'Viewer',
  CONTRIBUTOR = 'Contributor',
  CONTROLLER = 'Controller'
}

export enum USER_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  INVITATION_EXPIRED = 'invitation_expired',
  INVITED = 'invited'
}

export enum CONTENT_SHARED_WITH_TYPE {
  USER = 'RT_USER',
  USER_GROUP = 'RT_USER_GROUP'
}

export enum ACCOUNT_TYPE {
  REGULAR_USER = 'L_AT_RU',
  ORGANIZATION_ADMINISTRATOR = 'L_AT_OA',
  ORGANIZATION_OWNER = 'L_AT_OO',
  WORKSPACE_ADMINISTRATOR = 'L_AT_WA',
  TRIAL_ADMINISTRATOR = 'L_AT_TA',
  TRIAL_USER = 'L_AT_TU'
}
export enum PERSONA_TYPE {
  PROJECT_MANAGER_ASSISTANT = 'P_T_PMA',
  DEVELOPER_COMPANION = 'P_T_DC',
  STUDENT_STUDY_BUDDY = 'P_T_SSB',
  SALES_CRM_STRATEGIST = 'P_T_SCS',
  KNOWLEDGE_OPS_ANALYST = 'P_T_KOA',
  EXECUTIVE_ASSISTANT = 'P_T_EA',
  CUSTOMER_SUPPORT_AGENT_TRAINER = 'P_T_CSAT'
}

export enum ORGANIZATION_LOGO_TYPE {
  SIGN_IN_LOGO = 'L_OL_SL',
  EXPANDED_NAVBAR_LOGO = 'L_OL_EL',
  COLLAPSED_NAVBAR_LOGO = 'L_OL_CL',
  UNIFIED_LOGO = 'L_OL_UL'
}

export enum SUPPORTED_UPLOAD_FILES_FORMAT {
  PDF = 'application/pdf',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  ODS = 'application/vnd.oasis.opendocument.spreadsheet',
  ODP = 'application/vnd.oasis.opendocument.presentation',
  ODT = 'application/vnd.oasis.opendocument.text',
  RTF = 'text/rtf',
  MP3 = 'audio/mpeg',
  MP4 = 'video/mp4',
  MPGA = 'audio/mpeg',
  MPEG = 'video/mpeg',
  WAV = 'audio/wav',
  M4A = 'audio/x-m4a',
  WEBM = 'video/webm',
  MOV = 'video/quicktime',
  M4V = 'video/x-m4v',
  THREE_GP = 'video/3gpp',
  AAC = 'audio/aac',
  CAF = 'audio/x-caf',
  AMR = 'audio/amr',
  TXT = 'text/plain'
}

export enum SUPPORTED_IMAGE_FORMATS {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  GIF = 'image/gif'
}

export enum FILE_EXTENSIONS {
  PPT = 'ppt',
  PPTX = 'pptx',
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
  XLS = 'xls',
  XLSX = 'xlsx',
  CSV = 'csv',
  ODS = 'ods',
  ODP = 'odp',
  ODT = 'odt',
  BLOG_POST = 'blogpost',
  PAGE = 'page',
  HTML = 'html',
  NESTED_PAGE = 'nested page',
  WEB = 'web',
  RTF = 'rtf',
  DOT = 'dot',

  MP3 = 'mp3',
  MP4 = 'mp4',
  MPGA = 'mpga',
  MPEG = 'mpeg',
  WAV = 'wav',
  M4A = 'm4a',
  WEBM = 'webm',
  WEBA = 'weba',
  MOV = 'mov',
  M4V = 'm4v',
  THREE_GP = '3gp',
  AAC = 'aac',
  CAF = 'caf',
  AMR = 'amr',
  TXT = 'txt',
  JSON = 'json',

  PNG = 'png',
  JPEG = 'jpeg',
  JPG = 'jpg',
  GIF = 'gif',
  SVG = 'svg'
}

export enum LOOKUP {
  FILES = 'F_S',
  REACTION = 'R_T',
  REACTION_DETAILS = 'R_T_D',
  ACCOUNT_TYPE = 'LT_A_T',
  USERS = 'U_S',
  LT_SYNC_STATUS = 'LT_SYNC_STATUS',
  DOCUMENT_ANALYSIS_STATUS = 'LT_DA_S',
  PERSONA_TYPE = 'LT_P_T',
  ORGANIZATION_LOGO = 'LT_O_L',
  SUBSCRIPTION_STATUS = 'LT_L_S'
}

export const enum DOCUMENT_STATUS {
  PROCESSED = 'F_S_PR',
  INPROGRESS = 'F_S_UP',
  RETRYING = 'F_S_RE',
  UNSUPPORTED = 'F_S_US',
  WAITING_FOR_FILE = 'F_S_WF',
  LICENSE_LIMIT_REACHED = 'F_S_LLR',
  SMART_MEET_RESPONSE = 'L_SM_RC'
}

export const enum PROVIDER_STATUS {
  SYNC_STARTING = 'L_SS_SSG',
  SYNC_STARTED = 'L_SS_SSD',
  SYNC_RETRYING = 'L_SS_RET',
  SYNC_FAILED = 'L_SS_SFD',
  SYNC_COMPLETED = 'L_SS_SCD',
  SYNC_FILE_LIMIT_REACHED = 'L_SS_SFLR'
}

export const enum REACTION {
  THUMBS_DOWN = 'R_T_TD',
  THUMBS_UP = 'R_T_TU'
}

export enum ALERT {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

export enum VALUE_EXPR {
  ITEM = 'item',
  ID = 'id',
  NAME = 'name'
}

export enum RESPONSE_FEEDBACK_DETAILS {
  R_T_CWD = 'feedback1',
  R_T_OSD = 'feedback2',
  R_T_HOU = 'feedback3',
  R_T_NHF = 'feedback4'
}

export enum ACTION_TYPES {
  EDIT = 'edit',
  DELETE = 'delete',
  CANCEL = 'cancel',
  COMMIT = 'commit'
}

export enum CHAT_SOURCE_TYPES {
  ChatGPT = 'C',
  EmpowerGPT = 'E',
  AssistantGPT = 'A'
}

export enum CHAT_COUNT {
  ChatCount = 'chat_count'
}

export enum USER_TYPE {
  NON_AD = 'NON-AD',
  LDAP = 'LDAP',
  AZURE = 'AZURE'
}

export enum RESOURCE_PROVIDERS {
  SHAREPOINT = 'Sharepoint',
  ONEDRIVE = 'OneDrive',
  CONFLUENCE = 'Confluence',
  GOOGLEDRIVE = 'GoogleDrive'
}

export enum USAGE_STATS_TYPE {
  F = 'File Processing',
  E = 'Enterprise Knowledge Chat',
  C = 'World Knowledge Chat',
  'Data_Analysis' = 'Doc Analyst'
}

export enum AzureDetailsFields {
  CLIENT_ID = 'client_id',
  TENANT_ID = 'tenant_id',
  CLIENT_SECRET = 'client_secret',
  AD_USER_SEARCH_ENABLED = 'ad_user_search_enabled'
}

export enum AiModels {
  mistralLarge = 'Mistral-large',
  llama370BInstruct = 'Llama-3-70B-Instruct',
  llama3_1_70BInstruct = 'Llama-3-1-70B-Instruct',
  llama38BInstruct = 'Llama-3-1-8b-Instruct',
  gpt4Turbo = 'gpt-4-turbo',
  gpt432k = 'gpt-4-32k',
  gpt4o = 'gpt-4o',
  cohere = 'cohere',
  gpt35Turbo16k = 'gpt-3.5-turbo-16k',
  gpt35Turbo = 'gpt-3.5-turbo',
  gpt4 = 'gpt-4',
  llama90B = 'Llama-3-2-90B',
  llama405B = 'Llama-3-1-405B',
  minio1 = 'minio1',
  previewo1 = 'o1',
  mistralLarge2 = 'Mistral-large-02',
  deepSeekV3 = 'deepseek-v3',
  gpt4_1 = 'gpt-4-1',
  minio4 = 'minio4',
  gemini_2_flash = 'gemini-2.0-flash',
  gemini_2_5_flash = 'gemini-2.5-flash',
  gemini_3_1_pro = 'gemini-3-1-pro',
  gemini_3_pro_preview = 'gemini-3-pro-preview',
  gpt5 = 'gpt-5',
  gpt5_1 = 'gpt-5-1',
  claude_sonnet_4_6 = 'claude-sonnet-4.6',
  claude_opus_4_6 = 'claude-opus-4.6',
  grok_3 = 'grok-3',
  gpt5_2 = 'gpt-5-2',
  gpt5_3_chat = 'gpt-5-3-chat',
  gpt5_4 = 'gpt-5-4',
  claude_opus_4_7 = 'claude-opus-4.7',
  claude_opus_4_8 = 'claude-opus-4.8',
  gemini_3_5_flash = 'gemini-3.5-flash',
  claude_opus_5 = 'claude-opus-5',
  gpt_5_6_sol = 'gpt-5.6-sol',
  gpt_5_6_terra = 'gpt-5.6-terra',
  gpt_5_6_luna = 'gpt-5.6-luna'
}
export enum FileLanguage {
  en = 'English',
  de = 'German',
  it = 'Italian'
}

export enum ResourceTypes {
  Workspace = 'Workspace',
  Collection = 'Collection',
  Folder = 'Folder'
}

export enum OnboardingStepTypes {
  CHAT = 'chat',
  DOCUMENT = 'document',
  USER = 'user'
}

export enum DOC_ANALYST_TABS {
  ANALYSIS = 'analysis',
  DATASET = 'dataset',
  QUESTIONNAIRE = 'questionnaire',
  SMART_MEET = 'smart-meet'
}

export enum ASSISTANT_TABS {
  ALL = 'all',
  CREATED_BY_ME = 'created-by-me'
}

export const enum DOCUMENT_ANALYSIS_STATUS {
  COMPLETED = 'L_DA_CM',
  INPROGRESS = 'L_DA_IP',
  CANCELLED = 'L_DA_CN',
  FAILED = 'L_DA_FL',
  PARTIALLY_COMPLETED = 'L_DA_PC',
  REGENERATING = 'L_DA_RGR',
  DRAFT = 'L_DA_DR'
}

export enum ANALYSIS_QUESTION_STATUS {
  ANSWERED = 'L_DAC_AD',
  CREATED = 'L_DAC_CR',
  REGENERATING = 'L_DAC_RG',
  GENERATING = 'L_DAC_GR',
  FAILED = 'L_DAC_FD'
}

export enum PubsubEvents {
  STREAM = 'stream',
  CHAT_META = 'chat_meta',
  CHAT_STEP = 'chat_step',
  ERROR = 'error'
}

export enum SORT_TYPES {
  ASCENDING = 'asc',
  DESCENDING = 'desc'
}

export enum CHAT_CLASS {
  ASSISTANT = 'A',
  NORMAL = 'M',
  SMART_MEET = 'SM',
  DATA_ANALYST = 'I',
  PROJECT = 'P'
}

export enum PUBLIC_SHARED_RESOURCE_TYPES {
  ASSISTANT = 'ASSISTANT',
  CHAT = 'CHAT'
}

export enum VIEW_TYPE {
  GRID = 'grid',
  LIST = 'list'
}
export enum RATE_LIMIT_MODEL_TIERS {
  DEFAULT_MINI_EXPERT = 'default_mini_expert',
  MINI_EXPERT = 'mini_expert',
  DEFAULT_MODEL_TIERS = 'default_model_tiers',
  MODEL_TIERS = 'model_tiers'
}

export enum TOOLS_LIST {
  CANVAS = 'canvas',
  ENTERPRISE = 'enterprise__get_relevant_chunks',
  ENTERPRISE_LIST_DOCUMENTS = 'enterprise__list_documents',
  ATTACHMENTS = 'attached_documents',
  WEB_SEARCH = 'web_search',
  WEB_FETCH = 'web_fetch',
  DEFAULT = 'other',
  PLANNER = 'plan_and_execute',
  JOINNER = 'joinner',
  NANO_BANANA = 'nano-banana',
  FINALIZER = 'finalizer',
  CODE_EXECUTOR = 'code_executor'
}

export enum CHAT_STEP_NAME {
  TOOL_INPUT = 'tool_input',
  DOCUMENT_RECEIVED = 'document_received',
  PLAN = 'plan',
  ROUTE_SELECTED = 'route_selected',
  IMAGE_GENERATION = 'image_generation',
  TOOL_END = 'tool_end',
  FINAL = 'final',
  INTERRUPT = 'interrupt',
  TOOL_SELECTED = 'tool_selected'
}

export enum RESPONSE_QUALITY {
  GOOD = 'Good Responses',
  AVERAGE = 'Average Responses',
  BAD = 'Bad Responses'
}

export enum CHAT_STEP_MODE {
  RESPOND_SELECTION = 'respond_selection',
  EDIT_IMPLIED = 'edit_implied',
  FIND_AND_REPLACE = 'find_and_replace'
}

export enum ACTIONS_TABS {
  ALL = 'all',
  Added = 'added'
}

export enum CONNECTION_TYPE {
  DEFAULT = 'default',
  ADVANCED = 'advanced'
}

export enum ACTIONS_CATEGORIES {
  OUTLOOK_EMAIL = 'M_OUTLOOK_EMAIL',
  OUTLOOK_CALENDAR = 'M_OUTLOOK_CALENDAR',
  GMAIL = 'G_GMAIL',
  GOOGLE_CALENDAR = 'G_CALENDAR',
  GOOGLE_DRIVE = 'G_DRIVE',
  GOOGLE_SHEETS = 'G_SHEETS',
  SLACK = 'SLACK',
  HUBSPOT = 'HUBSPOT',
  JIRA = 'JIRA',
  CONFLUENCE = 'CONFLUENCE',
  MICROSOFT_SHAREPOINT = 'M_SHAREPOINT',
  MICROSOFT_ONEDRIVE = 'M_ONEDRIVE',
  MICROSOFT_TEAMS = 'M_TEAMS',
  GOOGLE_DOCS = 'G_DOCS',
  DATEV_ACCOUNTING = 'DATEV_ACCOUNTING',
  DATEV_HR = 'DATEV_HR',
  SQL_DATABASE = 'SQL_DATABASE',
  MICROSOFT_D365 = 'MICROSOFT_D365',
  SAP_S4HANA = 'SAP_S4HANA'
}

export enum SQL_DATABASE {
  EXECUTE_SQL = 'SQL_EXEC',
  SEARCH_OBJECTS = 'SQL_SRCH'
}

export enum MICROSOFT_D365 {
  LIST_CUSTOMERS = 'D365_CUST',
  LIST_VENDORS = 'D365_VEND',
  LIST_ITEMS = 'D365_ITEM',
  LIST_EMPLOYEES = 'D365_EMP',
  LIST_COMPANY_INFORMATION = 'D365_COINF',
  LIST_BANK_ACCOUNTS = 'D365_BANK',
  LIST_CURRENCIES = 'D365_CURR',
  LIST_SALES_INVOICES = 'D365_SINV',
  LIST_POSTED_SALES_INVOICES = 'D365_PSINV',
  LIST_SALES_CREDIT_MEMOS = 'D365_SCM',
  LIST_SALES_ORDERS = 'D365_SORD',
  LIST_CUSTOMER_PAYMENTS = 'D365_CPAY',
  LIST_PURCHASE_INVOICES = 'D365_PINV',
  LIST_POSTED_PURCHASE_INVOICES = 'D365_PPINV',
  LIST_PURCHASE_CREDIT_MEMOS = 'D365_PCM',
  LIST_PURCHASE_ORDERS = 'D365_PORD',
  LIST_VENDOR_PAYMENTS = 'D365_VPAY',
  LIST_GL_ACCOUNTS = 'D365_GL',
  LIST_GENERAL_LEDGER_ENTRIES = 'D365_GLE',
  LIST_TRIAL_BALANCES = 'D365_TB'
}

export enum SAP_S4HANA {
  LIST_MAINTENANCE_ORDERS = 'SAP_MO_LIST',
  GET_MAINTENANCE_ORDER = 'SAP_MO_GET',
  GET_MAINTENANCE_ORDER_OPERATIONS = 'SAP_MO_OPS',
  LIST_MAINTENANCE_NOTIFICATIONS = 'SAP_MN_LIST',
  GET_MAINTENANCE_NOTIFICATION = 'SAP_MN_GET',
  GET_MAINTENANCE_NOTIFICATION_ITEMS = 'SAP_MN_ITEMS',
  GET_MAINTENANCE_NOTIFICATION_TASKS = 'SAP_MN_TASKS',
  LIST_MATERIAL_STOCK = 'SAP_MS_LIST',
  GET_MATERIAL_STOCK = 'SAP_MS_GET',
  GET_MATERIAL_STOCK_QUANTITIES = 'SAP_MS_QTY',
  LIST_MATERIAL_DOCUMENTS = 'SAP_MD_LIST',
  GET_MATERIAL_DOCUMENT = 'SAP_MD_GET',
  LIST_MATERIAL_DOCUMENT_ITEMS = 'SAP_MD_ITEMS'
}

export enum OUTLOOK_EMAIL {
  CREATE_DRAFT = 'M_OE_CD',
  SEND_EMAIL = 'M_OE_SE',
  SEARCH_EMAIL_BY_CONTENT = 'M_OE_SEC',
  SEARCH_EMAIL_BY_CONTACT = 'M_OE_SES'
}

export enum OUTLOOK_CALENDAR {
  GET_TODAY_EVENTS = 'M_OC_GTE',
  GET_DATE_EVENTS = 'M_OC_GDE',
  CREATE_EVENT = 'M_OC_CE',
  UPDATE_EVENT = 'M_OC_UE',
  LIST_CALENDARS = 'M_OC_LC',
  LIST_CALENDAR_EVENTS = 'M_OC_LCE',
  DELETE_EVENTS = 'M_OC_DE',
  GET_EVENT = 'M_OC_GE'
}

export enum GOOGLE_GMAIL {
  SEND_EMAIL = 'G_GM_SE',
  SEARCH_EMAILS = 'G_GM_SCE',
  REPLY_EMAIL = 'G_GM_RE',
  CREATE_DRAFT = 'G_GM_CD',
  CREATE_DRAFT_REPLY = 'G_GM_CDR',
  GET_EMAIL_ATTACHMENTS = 'G_GM_GEA',
  SEARCH_PEOPLE = 'G_GM_SP'
}

export enum GOOGLE_CALENDAR {
  LIST_CALENDARS = 'G_CAL_LC',
  VIEW_EVENTS = 'G_CAL_VE',
  CREATE_EVENT = 'G_CAL_CE',
  UPDATE_EVENT = 'G_CAL_UE',
  DELETE_EVENT = 'G_CAL_DE',
  SEARCH_PEOPLE = 'G_CAL_SP'
}

export enum GOOGLE_DRIVE {
  GET_SHARED_DRIVES = 'G_DRV_GSD',
  GET_FOLDERS = 'G_DRV_GF',
  SEARCH_FILES = 'G_DRV_SF',
  DOWNLOAD_FILE = 'G_DRV_DF',
  SEARCH_PEOPLE = 'G_DRV_SP'
}

export enum SLACK {
  SEARCH_MESSAGES = 'SLK_SCHM',
  GET_PEOPLE = 'SLK_GP',
  GET_USER_BY_EMAIL = 'SLK_GUBE',
  GET_USER_INFO = 'SLK_GUI',
  LIST_USER_CONVERSATIONS = 'SLK_LUC',
  GET_MY_CHANNELS = 'SLK_GMC',
  GET_CHANNEL_INFO = 'SLK_GCI',
  GET_CHANNEL_MESSAGES = 'SLK_GCM',
  GET_THREAD_REPLIES = 'SLK_GTR',
  REPLY_TO_MESSAGE = 'SLK_RTM',
  SEND_MESSAGE = 'SLK_SM'
}

export enum HUBSPOT {
  FIND_COMPANIES = 'HS_FC',
  CREATE_COMPANY = 'HS_CC',
  UPDATE_COMPANY = 'HS_UC',
  SEARCH_COMPANIES = 'HS_SC',
  SEARCH_COMPANIES_ADVANCED = 'HS_SCA',
  GET_OWNERS = 'HS_GO',
  GET_USER_INFO = 'HS_GUI',
  GET_CONTACTS = 'HS_GC',
  CREATE_CONTACT = 'HS_CCT',
  UPDATE_CONTACT = 'HS_UCT',
  CREATE_DEAL = 'HS_CD',
  SEARCH_DEALS = 'HS_SD',
  UPDATE_DEAL = 'HS_UD',
  GET_COMPANY_RECENT_ACTIVITIES = 'HS_GCRA',
  GET_CONTACT_RECENT_ACTIVITIES = 'HS_GCTA',
  CREATE_TASK = 'HS_CT',
  CREATE_NOTE = 'HS_CN'
}

export enum JIRA {
  GET_ACCESSIBLE_RESOURCES = 'JR_GAR',
  GET_CURRENT_USER = 'JR_GCU',
  GET_ISSUE = 'JR_GI',
  GET_ISSUE_REMOTE_LINKS = 'JR_GIRL',
  GET_ISSUE_TYPE_FIELDS = 'JR_GITF',
  GET_PROJECT_ISSUE_TYPES = 'JR_GPIT',
  GET_ISSUE_LINK_TYPES = 'JR_GILT',
  GET_TRANSITIONS = 'JR_GT',
  GET_PROJECTS = 'JR_GP',
  LOOKUP_ACCOUNT_ID = 'JR_LAI',
  ADD_COMMENT = 'JR_AC',
  ADD_WORKLOG = 'JR_AW',
  CREATE_ISSUE = 'JR_CI',
  UPDATE_ISSUE = 'JR_UI',
  TRANSITION_ISSUE = 'JR_TI',
  SEARCH_ISSUES = 'JR_SI'
}

export enum CONFLUENCE {
  GET_ACCESSIBLE_RESOURCES = 'CF_GAR',
  GET_CURRENT_USER = 'CF_GCU',
  GET_PAGE = 'CF_GP',
  GET_PAGE_DESCENDANTS = 'CF_GPD',
  GET_PAGE_FOOTER_COMMENTS = 'CF_GPFC',
  GET_PAGE_INLINE_COMMENTS = 'CF_GPIC',
  GET_FOOTER_COMMENT_CHILDREN = 'CF_GFCC',
  GET_SPACES = 'CF_GS',
  GET_PAGES_IN_SPACE = 'CF_GPIS',
  CREATE_PAGE = 'CF_CP',
  UPDATE_PAGE = 'CF_UP',
  CREATE_FOOTER_COMMENT = 'CF_CFC',
  CREATE_INLINE_COMMENT = 'CF_CIC',
  SEARCH_CQL = 'CF_SC'
}

export enum MICROSOFT_TEAMS {
  SEARCH_MESSAGES = 'MST_SCHM',
  LIST_CHANNELS = 'MST_LC',
  GET_CHANNEL_MESSAGES = 'MST_GCM',
  GET_CHAT_MESSAGES = 'MST_GCHTM',
  SEND_CHANNEL_MESSAGE = 'MST_SCM',
  SEND_CHAT_MESSAGE = 'MST_SCHTM',
  LIST_CHATS = 'MST_LCHT',
  GET_CHAT_MEMBERS = 'MST_GCHTMB',
  LIST_MEETINGS = 'MST_LOM',
  GET_TRANSCRIPT = 'MST_GMT'
}

export enum GOOGLE_DOCS {
  SEARCH_DOCS = 'G_DOC_SD',
  CREATE_DOCUMENT = 'G_DOC_CD',
  FETCH_DOCUMENT_CONTENT = 'G_DOC_FDC',
  INSERT_TEXT = 'G_DOC_IT',
  REPLACE_TEXT = 'G_DOC_RT',
  FORMAT_TEXT = 'G_DOC_FT',
  FIND_AND_REPLACE_ALL = 'G_DOC_FRA'
}

export enum GOOGLE_SHEETS {
  SEARCH_FILES = 'G_SHT_SF',
  CREATE_ROWS = 'G_SHT_CR',
  UPDATE_ROWS = 'G_SHT_UR',
  LIST_ROWS = 'G_SHT_LR',
  GET_METADATA = 'G_SHT_GM',
  ADD_SHEET = 'G_SHT_AS'
}

export enum MICROSOFT_SHAREPOINT {
  GET_PROFILE = 'MSP_GP',
  LIST_DRIVES = 'MSP_LD',
  SEARCH_SITES = 'MSP_SS',
  GET_SITE = 'MSP_GS',
  LIST_SUBSITES = 'MSP_LSS',
  LIST_DRIVE_CHILDREN = 'MSP_LDC',
  LIST_RECENT_FILES = 'MSP_LRF',
  LIST_SITE_USERS = 'MSP_LSU',
  LIST_SITE_LISTS = 'MSP_LSL',
  GET_LIST = 'MSP_GL',
  LIST_COLUMNS = 'MSP_LC',
  GET_COLUMN = 'MSP_GC',
  LIST_LIST_ITEMS = 'MSP_LLI',
  GET_LIST_ITEM = 'MSP_GLI',
  LIST_SITE_PAGES = 'MSP_LSP',
  GET_GROUPS = 'MSP_GG',
  GET_GROUP_MEMBERS = 'MSP_GGM',
  ADD_GROUP_MEMBER = 'MSP_AGM',
  REMOVE_GROUP_MEMBER = 'MSP_RGM',
  SEARCH_FILES = 'MSP_SF',
  UPLOAD_FILE = 'MSP_UF',
  GET_FOLDER = 'MSP_GF'
}

export enum DATEV_ACCOUNTING {
  LIST_CLIENTS = 'DA_LC',
  GET_CLIENT = 'DA_GC',
  GET_FISCAL_YEARS = 'DA_GFY',
  GET_FISCAL_YEAR = 'DA_GF',
  GET_GENERAL_LEDGER_ACCTS = 'DA_GLA',
  GET_SUMS_AND_BALANCES = 'DA_GSB',
  GET_ACCOUNTING_SEQUENCES = 'DA_GAS',
  GET_TERMS_OF_PAYMENT = 'DA_GTP',
  GET_DOCUMENT_TYPES = 'DA_GDT',
  GET_DUO_VERSION = 'DA_GDV'
}

export enum DATEV_HR {
  LIST_HR_CLIENTS = 'DH_LC',
  GET_HR_CLIENT = 'DH_GC',
  GET_EMPLOYEE_MASTER_DATA = 'DH_EMD',
  GET_EMPLOYEE_SALARY_DETAILS = 'DH_ESD',
  GET_EMPLOYEE_TAX_PAYMENTS = 'DH_ETP',
  GET_EMPLOYEE_SOCIAL_SECURITY = 'DH_ESP',
  GET_EMPLOYEE_ABSENCES = 'DH_EA',
  GET_EMPLOYEE_ID_BY_PERSONNEL_NUM = 'DH_EID',
  GET_ALL_EMPLOYEES_MASTER_DATA = 'DH_AMD',
  GET_ALL_EMPLOYEES_SALARY_DETAILS = 'DH_ASD',
  GET_ALL_EMPLOYEES_TAX_PAYMENTS = 'DH_ATP',
  GET_ALL_EMPLOYEES_SOCIAL_SECURITY = 'DH_ASP',
  GET_ALL_EMPLOYEES_ABSENCES = 'DH_AA',
  GET_PAYROLL_CLIENT = 'DH_GPC',
  GET_PAYROLL_REPORTS = 'DH_GPR',
  GET_PAYROLL_DOCUMENT_AVAILABILITY = 'DH_GDA',
  GET_EMPLOYEE_PAYSLIP_NUMBERS = 'DH_EPN',
  GET_PAYROLL_REPORT_METADATA = 'DH_GRM'
}

export enum MICROSOFT_ONEDRIVE {
  LIST_AVAILABLE_DRIVES = 'MOD_LAD',
  GET_FOLDER_BY_PATH = 'MOD_GFBP',
  SEARCH_FOLDERS_BY_NAME = 'MOD_SFBN',
  SEARCH_FILES_BY_NAME = 'MOD_SFBN2',
  CREATE_FOLDER = 'MOD_CF',
  LIST_FOLDER_CHILDREN = 'MOD_LFC',
  DOWNLOAD_FILE = 'MOD_DF'
}

export enum ICON_TYPE {
  ORGANIZATION_LOGO = 'OL',
  ASSISTANT_LOGO = 'AL'
}

export enum ACTION_INTERRUPT_TYPE {
  USER_CONFIRMATION = 'user_confirmation',
  USER_AUTH = 'user_auth'
}
export enum SUBSCRIPTION_NAME {
  ENTERPRISE = 'Enterprise',
  ESSENTIALS = 'Essentials',
  TRIAL = 'Trial',
  PROFESSIONAL = 'Professional'
}

export enum SUBSCRIPTION_STATUS {
  ACTIVE = 'L_L_S_AC',
  IN_ACTIVE = 'L_L_S_IAC',
  CANCELLED = 'L_L_S_CND',
  PAST_DUE = 'L_L_S_PSD',
  BLOCKED = 'L_L_S_BD',
  EXPIRED = 'L_L_S_EX',
  RENEWED = 'L_L_S_RND'
}

export enum SUBSCRIPTION_INTERVAL {
  MONTHLY = 'BILLING_PERIOD_MONTHLY',
  YEARLY = 'BILLING_PERIOD_YEARLY'
}

export enum SUBSCRIPTION_PLAN {
  TRIAL = 'trial',
  ESSENTIALS = 'essentials',
  PROFESSIONAL = 'professional',
  ENTERPRISE = 'enterprise'
}

export enum SUBSCRIPTION_CODE {
  TRIAL = 'TIER_TRIAL',
  ESSENTIALS = 'TIER_ESSENTIALS',
  PROFESSIONAL = 'TIER_PROFESSIONAL',
  ENTERPRISE = 'TIER_ENTERPRISE',
  STANDARD = 'TIER_STANDARD'
}

export enum ADD_ON_CODE {
  WORKFLOW_RUNS = 'ADDON_WORKFLOW_RUNS'
}

export enum LICENSE_STATUSES {
  BLOCKED = 'Blocked',
  CUSTOM = 'Custom',
  TRIAL = 'Trial',
  STANDARD = 'Standard'
}

export enum LICENSE_STATE {
  STANDARD = 'standard',
  PAYG_AVAILABLE = 'payg_available',
  PAYG_ACTIVE = 'payg_active'
}

export enum CREDITS_POOL_STATE {
  OK = 'ok',
  NEARING_LIMIT = 'nearing_limit',
  LIMIT_REACHED = 'limit_reached'
}

export enum DISCLAIMER_ACTION_KIND {
  PAYG_SETTINGS = 'payg_settings',
  CONTACT_SUPPORT = 'contact_support'
}

export enum SMART_MEET_EVENT_TYPE {
  RESPONSE = 'SMART_MEET_RESPONSE',
  STATUS = 'SMART_MEET_STATUS'
}

export enum DEFAULT_LANG {
  EN = 'en',
  DE = 'de',
  IT = 'it'
}

export enum NOTIFICATION_EVENT_TYPE {
  NOTIFICATION = 'NOTIFICATION',
  ORG_NOTIFICATION_PREF_UPDATED = 'ORG_NOTIFICATION_PREF_UPDATED'
}

export enum WORKFLOW_EVENT_TYPE {
  WORKFLOW_STARTED = 'WORKFLOW_STARTED',
  WORKFLOW_COMPLETED = 'WORKFLOW_COMPLETED',
  WORKFLOW_FAILED = 'WORKFLOW_FAILED',
  WORKFLOW_CANCELLED = 'WORKFLOW_CANCELLED',
  WORKFLOW_PAUSED = 'WORKFLOW_PAUSED',
  WORKFLOW_RESUMED = 'WORKFLOW_RESUMED',
  /** Run progress: PubSub payloads often use lowercase `event`: `node_started`. */
  NODE_STARTED = 'NODE_STARTED',
  /** Phase text while a node runs (repeats between started and completed). */
  NODE_INPROGRESS = 'NODE_INPROGRESS',
  NODE_COMPLETED = 'NODE_COMPLETED',
  NODE_FAILED = 'NODE_FAILED'
}

export enum PUBSUB_EVENT_TYPE {
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  DOC_ANALYSIS_QUESTIONS_EVENT = 'DOC_ANALYSIS_QUESTIONS_EVENT',
  DOC_ANALYSIS_EVENT = 'DOC_ANALYSIS_EVENT',
  ACTION_CONNECTOR_EVENT = 'ACTION_CONNECTOR_EVENT',
  FILE_PROCESSING_CSC_EVENT = 'FILE_PROCESSING_CSC_EVENT',
  FILE_SYNC_CSC_EVENT = 'FILE_SYNC_CSC_EVENT',
  REALM_DELETED = 'REALM_DELETED',
  USER_DELETED = 'USER_DELETED'
}

//  Reasoning effort a model can be asked for on chat.
//  Declaration order is the weakest-to-strongest order the menu renders in
//  (THINKING_EFFORT_ORDER is derived from it), so add members in position.
export enum THINKING_EFFORT {
  OFF = 'off',
  MINIMAL = 'minimal',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  XHIGH = 'xhigh',
  MAX = 'max'
}
